<template>
  <div>
    <layout-one>
      <div>
        <span>考试批次：</span>
        <el-select v-model="requestForm.planId" placeholder="请选择批次">
          <el-option
            v-for="item in siteData"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div>
        <span>考点：</span>
        <el-select v-model="requestForm.placeId" placeholder="请选择考点">
          <el-option
            v-for="item in placeIdList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div>
        <div v-for="(item, index) in iphonelist" :key="index"  prop="phone">
          <span>手机号：</span>
          <el-input :maxlength="11" v-model="item.teacherPhone" placeholder="请输入正确的手机号"></el-input>
          <i
            v-if="index > 0"
            class="ml10 iconfont icon-shanchu"
            @click="deleteClassObj(index)"
          ></i>
          <i class="col_blue mt10 cp" v-if="index < 1"
            ><i @click="addClassObj" class="el-icon-plus mr5"></i
          ></i>
        </div>
      </div>

      <el-button round @click="$router.go(-1)">取消</el-button>
      <el-button type="primary" @click="addSchool" round>确定</el-button>
    </layout-one>
  </div>
</template>
<script>
import { setsaveInfo } from "@/http/modules/baseSet/majorCourse";
import { getSelectPlanFn } from "@/http/modules/examSet/examBatch";
import { getPlanSite } from "@/http/modules/examSet/section";
export default {
  name: "setSettingsIphone",
  data() {
    return {
      siteData: [],
      placeIdList: [],
      requestForm: {
        planId: "",
        placeId: "",
        teacherName: "",
        teacherPhone: "",
      },
      iphonelist: [{ teacherPhone: "" }],
    };
  },
  watch: {
    "requestForm.planId"(val) {
      this.initSiteData(val);
      this.requestForm.placeId = "";
    },
  },
  created() {
    this.initData();
  },
  methods: {
    async initData() {
      let { data } = await getSelectPlanFn({ needAudit: 6 });
      this.siteData = data;
    },
    initSiteData(planId) {
      getPlanSite({ planId: planId }).then((res) => {
        this.placeIdList = res.data;
      });
    },
    addClassObj() {
      let obj = {};
      this.iphonelist.push(obj);
    },
    deleteClassObj(index) {
      this.iphonelist.splice(index, 1);
    },
    addSchool() {
      let teacherPhonelist = this.iphonelist.map((item) => {
        return item.teacherPhone;
      });
      console.log(teacherPhonelist)
      let phoneReg = /^1([3-9][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[1,8,9])\d{8}$/;
      let yesPhone = true
      teacherPhonelist.forEach((item)=>{
       if(phoneReg.test(item)){
        yesPhone = true
       }else{
        yesPhone = false
      
       }
      })
      if(yesPhone){
        this.requestForm.teacherPhone = teacherPhonelist.toString();
        setsaveInfo(this.requestForm).then((res) => {
          if (res.code == 1) {
            this.$message.success("设置成功");
            this.$router.go(-1);
          }
        });
      }else{
        this.$message.error('请输入正确的手机号')
      }
      

    },
  },
};
</script>
<style lang="less" scoped>
div {
  margin-bottom: 20px;
  span {
    width: 80px;
    display: inline-block;
    text-align: right;
  }
  i {
    margin-left: 5px;
  }
}
</style>